import { EventStats } from "./types";
import { usd } from "./helpers";

interface EventStatsBarProps {
  stats: EventStats;
  eventName: string;
}

export const EventStatsBar = ({ stats, eventName }: EventStatsBarProps) => (
  <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
    <div className="flex items-center justify-between mb-4">
      <h1 className="text-xl font-bold text-gray-900">Vendor Payouts</h1>
      {eventName && (
        <span className="text-sm font-medium text-gray-500">{eventName}</span>
      )}
    </div>
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      <StatCard
        label="Total Revenue"
        value={usd(stats.totalRevenue)}
        color="text-gray-900"
      />
      <StatCard
        label="Total Tax"
        value={usd(stats.totalTax)}
        color="text-gray-600"
      />
      <StatCard
        label="Total Deductions"
        value={usd(stats.totalDeductions)}
        color="text-red-700"
      />
      <StatCard
        label="Total Payouts Due"
        value={usd(stats.totalPayoutsDue)}
        color={stats.totalPayoutsDue < 0 ? "text-red-700" : "text-green-700"}
      />
      <StatCard
        label="Vendor-Locations"
        value={String(stats.vendorLocationCount)}
        color="text-gray-900"
        plain
      />
    </div>
  </div>
);

const StatCard = ({
  label,
  value,
  color,
  plain,
}: {
  label: string;
  value: string;
  color: string;
  plain?: boolean;
}) => (
  <div className="flex flex-col">
    <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">
      {label}
    </span>
    <span
      className={`text-lg font-bold ${color} ${plain ? "" : "tabular-nums"}`}
    >
      {value}
    </span>
  </div>
);
